export default {
  UPPER: 'UPPER',
  LOWER: 'LOWER',
  BOTH: 'BOTH',
} as const
